import { render, staticRenderFns } from "./uploadIDCardDialog.vue?vue&type=template&id=4d737002&scoped=true&"
import script from "./uploadIDCardDialog.vue?vue&type=script&lang=js&"
export * from "./uploadIDCardDialog.vue?vue&type=script&lang=js&"
import style0 from "./uploadIDCardDialog.vue?vue&type=style&index=0&id=4d737002&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d737002",
  null
  
)

export default component.exports